import { render, staticRenderFns } from "./Lao12zodiac.vue?vue&type=template&id=2fdac40d&"
import script from "./Lao12zodiac.vue?vue&type=script&lang=js&"
export * from "./Lao12zodiac.vue?vue&type=script&lang=js&"
import style0 from "./Lao12zodiac.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports